export const SIDE_NAV_MAP = {
    Sales: {
        route: '/sales',
        ref: 'NAV_SALES',
        alt: 'Redirects to the sales page.',
    },
    Customers: {
        route: '/customers',
        ref: 'NAV_CUSTOMERS',
        alt: 'Redirects to the customers page.',
    },
    Competition: {
        route: '/competition',
        ref: 'NAV_COMPETITION',
        alt: 'Redirects to the competition page.',
    },
    Goals: {
        route: '/goalsetting',
        ref: 'NAV_GOALS',
        alt: 'Redirects to the goals page.',
    },
    Insights: {
        route: '/insights',
        ref: 'NAV_INSIGHTS',
        alt: 'Redirects to the insights page.',
    },
};
export const dialogLinks = {
    ONBOARDING_COMPLETED: '/sales?dialog=onboarding-completed',
};
export const notificationInterval = 300000; // 5 minutes
